import { render, staticRenderFns } from "./ProductSelectComponent.vue?vue&type=template&id=e2f41006"
import script from "./ProductSelectComponent.vue?vue&type=script&lang=js"
export * from "./ProductSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports